import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { OrgAPI } from "pages/organization/org.service";
const initialState = {
  data: [],
  state: ""
};
export const groupsSlice = createSlice({
  name: "groups",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getGroups.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getGroups.pending, (state, action) => {
        state.state = "pending";
      });
  }
});

export const getGroups = createAsyncThunk('groups/get', async(query) => {
  
  let data = await OrgAPI.getOrgGroups();
  return data['groups'];

});


export default groupsSlice.reducer;